// NOTE: Mixins in TS require any type of constructor
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Constructor<T = object> = new (...args: any[]) => T;

export enum LogLevel {
  DEBUG,
  INFO,
  WARN,
  ERROR,
}

export type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>;
    }
  : T;
